var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import { DataImportExcelInfoService } from "~/services/dataimp-service/data-import-excel-info.service.ts";
import { DataGrid, DataGridItem } from "@zct1989/vue-component";
import { namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace("collection-execution");
var CustInfo = /** @class */ (function (_super) {
    __extends(CustInfo, _super);
    function CustInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.personalInfo = {};
        _this.personalBankInfo = {};
        _this.personalContacts = [];
        _this.personalHouse = {};
        _this.personalIncome = {};
        return _this;
    }
    Object.defineProperty(CustInfo.prototype, "isImport", {
        /**
         * 是否导入
         */
        get: function () {
            return MENU_CHANNEL.Case_imported === this.menuChannel;
        },
        enumerable: false,
        configurable: true
    });
    CustInfo.prototype.activated = function () {
        this.refreshData();
    };
    CustInfo.prototype.refreshData = function () {
        this.getPersonalInfo();
        this.getBankInfo();
        // this.getContacts();
        this.getHouseInfo();
        this.getIncome();
    };
    /**
     * 获取客户信息
     */
    CustInfo.prototype.getPersonalInfo = function () {
        var _this = this;
        if (this.menuChannel === MENU_CHANNEL.Case_imported) {
            this.dataImportExcelInfoService
                .getImportPersonalInfo(this.caseId)
                .subscribe(function (data) { return (_this.personalInfo = data); });
        }
        else {
            this.caseOperatorPageService
                .personalInfo(this.caseId)
                .subscribe(function (data) { return (_this.personalInfo = data); });
        }
    };
    /**
     * 获取客户开户信息
     */
    CustInfo.prototype.getBankInfo = function () {
        var _this = this;
        if (this.isImport) {
            this.dataImportExcelInfoService
                .getImportPersonalBank(this.caseId)
                .subscribe(function (data) { return (_this.personalBankInfo = data); });
        }
        else {
            this.caseOperatorPageService
                .personalBankInfo(this.caseId)
                .subscribe(function (data) { return (_this.personalBankInfo = data); });
        }
    };
    /**
     * 获取联系人信息
     */
    CustInfo.prototype.getContacts = function () {
        var _this = this;
        if (this.isImport) {
            this.dataImportExcelInfoService
                .getImportPersonalContacts(this.caseId)
                .subscribe(function (data) {
                _this.personalContacts = data;
            });
        }
        else {
            this.caseOperatorPageService
                .personalContacts(this.caseId)
                .subscribe(function (data) { return (_this.personalContacts = data); });
        }
    };
    /**
     * 获取客户房产信息
     */
    CustInfo.prototype.getHouseInfo = function () {
        var _this = this;
        if (this.isImport) {
            this.dataImportExcelInfoService
                .getImportPersonalHouse(this.caseId)
                .subscribe(function (data) { return (_this.personalHouse = data); });
        }
        else {
            this.caseOperatorPageService
                .queryPersonalHouse(this.caseId)
                .subscribe(function (data) { return (_this.personalHouse = data); });
        }
    };
    /**
     * 获取客户收支状况
     */
    CustInfo.prototype.getIncome = function () {
        var _this = this;
        if (this.isImport) {
            this.dataImportExcelInfoService
                .getImportPersonalIncome(this.caseId)
                .subscribe(function (data) { return (_this.personalIncome = data); });
        }
        else {
            this.caseOperatorPageService
                .queryPersonalIncome(this.caseId)
                .subscribe(function (data) { return (_this.personalIncome = data); });
        }
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], CustInfo.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CustInfo.prototype, "dataImportExcelInfoService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CustInfo.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], CustInfo.prototype, "menuChannel", void 0);
    CustInfo = __decorate([
        Component({
            components: {
                DataGrid: DataGrid,
                DataGridItem: DataGridItem
            }
        })
    ], CustInfo);
    return CustInfo;
}(Vue));
export default CustInfo;
